import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lease-vs-buy',
  component: () => import('../../routes/LeaseBuy.svelte'),
  card: {
    id: 'lease-vs-buy',
    title: 'Lease vs Buy (Car)',
    description: 'Compare the total cost of leasing vs buying a vehicle over time. See monthly payments, total costs, and which option saves you more.',
    icon: 'car_rental',
    iconBgClass: 'bg-slate-50',
    iconTextClass: 'text-slate-600',
    href: '/lease-vs-buy',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Lease vs Buy Car Calculator – Compare Leasing vs Buying a Vehicle',
    description: 'Free lease vs buy car calculator. Compare the total cost of leasing versus buying a vehicle with monthly payment breakdowns, total cost analysis, equity tracking, and a clear side-by-side comparison to find which option saves you more.',
  },
};

export default meta;
